<script setup lang="ts">

</script>

<template>
  <div class="sticky z-30 ml-20 font-semibold text-xs flex justify-between items-center">
    <div class="w-1/3">
      <slot name="left" />
    </div>
    <div class="w-1/3 text-center">
      <slot name="center" />
    </div>
    <div class="w-1/3 text-right">
      <slot name="right" />
    </div>
  </div>
</template>